/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type SectionTemplateSortOrder = typeof SectionTemplateSortOrder[keyof typeof SectionTemplateSortOrder];


export const SectionTemplateSortOrder = {
  TemplateName: 'TemplateName',
  SectionThenTemplateName: 'SectionThenTemplateName',
} as const;
